import { Box } from '@mui/material'
import React from 'react'

export default function RangedMax() {
  return (
    <Box display={'flex'} justifyContent={'center'}>
      Ranged max hit
    </Box>
  )
}
